import { ApiRequest } from "./base";

const apiRoute = "user";

export const UserApi = {
	async getInfo() {
		return ApiRequest(`${apiRoute}`, "GET");
	},
	async update(data) {
		return ApiRequest(`${apiRoute}/update`, "POST", data);
	},
	async fetchOrderTrackingData(orderId) {
		return ApiRequest(`${apiRoute}/order-tracking/${orderId}`, "GET");
	},
	async LoyaltyOptIn(user_id) {
		return ApiRequest(`${apiRoute}/opt-in-rewards`, "POST", { user_id });
	},
	async getTrackingInformation(email, id) {
		return ApiRequest(`${apiRoute}/order-tracking`, "POST", {
			id: id,
			email: email,
		});
	},
};
